import React from 'react';
import styles from './SimpleList.module.css';

const TrashIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m2 0-1 13a1 1 0 01-1 1H8a1 1 0 01-1-1L6 7h12z"/>
    </svg>
);

// A compact list for a handful of items inside a card (org members, folders,
// assignees) - lighter than the DataList family, which assumes a full-page
// table with search/sort/bulk-select.
export const SimpleList = ({children}) => (
    <ul className={styles.list}>{children}</ul>
);

export const SimpleListRow = ({primary, secondary, onRemove, removeLabel}) => (
    <li className={styles.row}>
        <span className={styles.text}>
            <span className={styles.primary}>{primary}</span>
            {secondary && <span className={styles.secondary}>{secondary}</span>}
        </span>
        {onRemove && (
            <button type="button" className={styles.removeButton} aria-label={removeLabel} onClick={onRemove}>
                <TrashIcon/>
            </button>
        )}
    </li>
);
